import Table from '@/components/table';
import { useFetchPaginated } from '@/hooks/useFetch';
import { FunctionComponent } from 'react';
import { getPaginatedFeatures } from '@/communication/feature';
import { useNavigate } from 'react-router-dom';

const FeaturesList: FunctionComponent = () => {
    const { data: response, paginationData } = useFetchPaginated({
        queryFn: (page, itemsPerPage) => getPaginatedFeatures({ page, itemsPerPage }),
    });
    const nav = useNavigate();

    return (
        <Table
            items={response?.features ?? []}
            getRowIdentifier={(item) => item.id}
            columns={[
                { accessorKey: 'id', header: 'Id' },
                { accessorKey: 'title', header: 'Title' },
                { accessorKey: 'content', header: 'Content' },
                { accessorKey: 'image', header: 'Image' },
            ]}
            pagination={paginationData}
            handleEdit={(feature) => nav(`${feature.id}`)}
            createButtonText="Create Feature"
            handleCreateButtonClick={() => nav('create')}
        />
    );
};
export default FeaturesList;
